import { ObjectsFactory, Model, IHttpError, IResponse } from './core'
import { useMutation } from '@tanstack/react-query'

export interface IFile {
  id: number
  name: string
  path: string
  object_type: string
  object_id: number
  type: string
  large_path: string
  medium_path: string
  small_path: string
  tiny_path: string
  tiny_url: string
  medium_url: string
  large_url: string
  path_url: string
  url: string
}

const modelConfig = {
  path: '/files'
}

export interface IFileUploadPayload {
  files: File
  object_type: string
  type: string
}

export enum Fileobject_type {
  USER = 'users',
  BRANCH = 'branches',
  TRANSACTION = 'transactions',
  POINT = 'points',
  COMMISSION = 'commissions'
}

export class FileObject extends Model {
  static queryKeys = {
    paginate: 'FILE_PAGINATE_QUERY',
    findOne: 'BRANCHS_FIND_ONE_QUERY'
  }

  static objects = ObjectsFactory.factory<IFile>(modelConfig, this.queryKeys)

  static upload({ files, object_type, type }: IFileUploadPayload) {
    return this.api.uploadFile<IResponse<IFile>>(`${modelConfig.path}`, files, {
      object_type,
      type
    })
  }
}

FileObject.setup(modelConfig)

export function useFileUploadMutation() {
  return useMutation<IResponse<IFile>, IHttpError, IFileUploadPayload>({
    mutationFn: payload => {
      return FileObject.upload(payload).then(r => r.data)
    }
  })
}
